import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";

function Scenario5({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  return (
    <div className="h-100">
      <div className="container-fluid">
        <div className="row h-100">
          <div
            className="col-md-12 d-flex flex-column justify-content-around px-5 mt-5"
          >
            <h5 className="mb-2">Esta cronología resume su trayectoria clínica:</h5>
            <div className="d-flex flex-column align-items-center">
            </div>
            <div className="mt-5 d-flex align-items-center justify-content-end w-100">
              {/* Botón siguiente */}
              <NextButton
                navigateTo={ROUTES.SCENARIO5_SEGUIMIENTO2}
                activeScenario={activeScenario}
                color="green"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario5);
